<div class="drag-and-drop-template" (click)="triggerFileSelector()">
  <i class="fa fa-upload fa-5x"></i>
  <p>Dra dina filer hit eller välj en fil genom att klicka här.</p>
</div>
